/* istanbul ignore file */
import React from 'react';
import MuiFade, { FadeProps } from '@mui/material/Fade';

const Fade = ({ in: isShow = true, timeout = 20, ...props }: FadeProps) => {
  return <MuiFade {...props} in={isShow} timeout={timeout} />;
};

export default Fade;
